module.exports = __webpack_public_path__ + "img/icon-mail.38bd53b2.svg";